import { render, staticRenderFns } from "./MatchScoreCard.vue?vue&type=template&id=c25eec6e&scoped=true&"
import script from "./MatchScoreCard.vue?vue&type=script&lang=js&"
export * from "./MatchScoreCard.vue?vue&type=script&lang=js&"
import style0 from "./MatchScoreCard.vue?vue&type=style&index=0&id=c25eec6e&lang=scss&scoped=true&"
import style1 from "./MatchScoreCard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c25eec6e",
  null
  
)

export default component.exports